import classNames from 'classnames';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PinchZoom, { make3dTransformValue } from 'react-quick-pinch-zoom';
import ProductVideo from './ProductVideo';
let zoomTimerId;
const ProductGalleryImage = (props) => {
    const { t } = useTranslation();
    const zoomRef = useRef();
    const imgRef = useRef();
    const [isDragging, setIsDragging] = useState(false);
    const [zoomPos, setZoomPos] = useState({
        x: 0,
        y: 0,
        scale: 1,
    });
    const onUpdate = useCallback(({ x, y, scale }) => {
        const { current: img } = imgRef;
        if (img) {
            clearTimeout(zoomTimerId);
            zoomTimerId = setTimeout(() => {
                setZoomPos({ x, y, scale });
            }, 100);
            const value = make3dTransformValue({ x, y, scale });
            img.style.setProperty('transform', value);
        }
    }, []);
    const zoomOut = () => {
        zoomRef === null || zoomRef === void 0 ? void 0 : zoomRef.current.scaleTo({
            x: window.innerWidth / 2,
            y: window.innerHeight / 2,
            scale: zoomPos.scale - 0.5,
        });
    };
    const zoomIn = () => {
        zoomRef === null || zoomRef === void 0 ? void 0 : zoomRef.current.scaleTo({
            x: window.innerWidth / 2,
            y: window.innerHeight / 2,
            scale: zoomPos.scale + 0.5,
        });
    };
    useEffect(() => {
        if (props.activateIndex) {
            zoomPos.scale = 1;
            document.querySelectorAll('.zoom-img-wrapper').forEach((e) => {
                let img = e;
                img.style.removeProperty('transform');
            });
        }
    }, [props.activateIndex]);
    const hasVideo = () => {
        return ['_V1', '_V2', '_V3', '_V4', '_V5', '_V6', '_V7', '_V8', '_V9', '_V10'].some((e) => props.media[props.index].includes(e));
    };
    return (React.createElement("div", { className: classNames('gallery-wrapper', { scaling: zoomPos.scale > 1 }) }, hasVideo() ? (React.createElement("div", { className: "gallery-wrapper__video" },
        React.createElement(ProductVideo, { url: props.media[props.index], inZoomModal: true }),
        React.createElement("button", { className: "product-video-pause", "aria-label": t('button.pause'), "data-pause": true, "aria-pressed": "false" }))) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "modal__zoom-controls" },
            React.createElement("button", { "aria-label": t('button.zoomout'), disabled: zoomPos.scale <= 1, className: "modal__zoom-out", onClick: zoomOut }),
            React.createElement("span", { className: "modal__zoom-scale" },
                Math.round(zoomPos.scale * 100),
                "%"),
            React.createElement("button", { "aria-label": t('button.zoomin'), disabled: zoomPos.scale >= 2, className: "modal__zoom-in", onClick: zoomIn })),
        React.createElement(PinchZoom, { ref: zoomRef, onUpdate: onUpdate, maxZoom: 2, minZoom: 1, onDragStart: () => setIsDragging(true), onDragEnd: () => setIsDragging(false) },
            React.createElement("div", { className: "zoom-img-wrapper", ref: imgRef },
                React.createElement("img", { className: classNames('zoom-image-wrapper', { dragging: isDragging }), src: props.src || props.media[props.index], alt: "", loading: "lazy" })))))));
};
export default ProductGalleryImage;
